




























































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { AppData } from "@/models/app-data";
import { required } from "vuelidate/lib/validators";
import CommonMixin from "@/mixins/common-mixins";
import { Route } from "vue-router";
import { ContentService } from "@/service/content.service";
import { Child2Content } from "@/models/content/child-2";
import VRuntimeTemplate from "v-runtime-template";

@Component({
  components: {
    FooterButton,
    VRuntimeTemplate,
  },
  validations: {
    birthdate: {
      required,
    },
    specialNeeds: {
      required,
    },
    specialNeedsPlan: {
      needPlan(): boolean {
        const model = this as Child2;
        if (model.specialNeeds === true) {
          return model.specialNeedsPlan != undefined;
        } else {
          return true;
        }
      },
    },
  },
})
export default class Child2 extends Mixins(CommonMixin) {
  content = {} as Child2Content;
  appData = {} as AppData;
  birthdayTemplate = "";
  specialNeedsTemplate = "";
  specialNeedsPlanTemplate = "";
  childName = "";
  birthdate = new Date();
  specialNeeds = false;
  specialNeedsPlan = false;
  PercentDone = 50;
  childIndex = 0;
  textDirection = "ltr";
  language = ''

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getChild2Content();
      this.textDirection = contentService.TextDirection();
      this.language = contentService.Language();

      await this.loadPage(this.$route.params.index);
      this.putWorkflowStep( this.appData?.workflowId, "Child2") 
    } catch (error) {
      this.showError(error);
    }
  }

  disableNext(): boolean {
    return this.$v.$invalid;
  }

  public handleNextPageEvent(): void {
    this.saveData();
    const numChildren = this.appData.children.length;
    if (this.childIndex < numChildren - 1) {
      this.$router.replace({ params: { index: `${this.childIndex + 1}` } });
    } else {
      let path = '/HouseholdInformation';

      const language = this.$router.currentRoute.params.lang;
      if ( language != null ){
        path = `/${language}/HouseholdInformation`;
      } 

      this.$router.push({ path: path });
    }
  }

  saveData(): void {
    const child = this.appData.children[this.childIndex];
    child.birthdate = this.birthdate;
    child.specialNeeds = this.specialNeeds;
    child.hasSpecialNeedsPlan = this.specialNeedsPlan;
    this.saveAppData(this.appData);
  }

  /* typescript-eslint-disable no-implicit-any */
  async beforeRouteUpdate(to: Route, from: Route, next: any) {
    if (to.name == "Child2") {
      await this.loadPage(to.params.index);
    }
    next();
  }

  async loadPage(childIndex: string): Promise<void> {
    this.childIndex = Number(childIndex);
    this.appData = this.getAppData();

    if (this.appData != null && this.appData.children != null) {
      const child = this.appData.children[this.childIndex];

      this.childName = child.fullName;
      this.birthdate = child.birthdate;
      this.specialNeeds = child.specialNeeds;
      this.specialNeedsPlan = child.hasSpecialNeedsPlan;

      this.birthdayTemplate = `
            <span>
              ${this.content.Birthday}
            </span>
      `;

      this.specialNeedsTemplate = `
            <span>
              ${this.content.SpecialNeeds}
            </span>
      `;

      this.specialNeedsPlanTemplate = `
            <span>
              ${this.content.SpecialNeedsPlan}
            </span>
      `;
    }
  }
}
